// 新闻管理
const goodsManage = () => import('@/view/goods/goods-manage'); // 轮播图
const good = () => import('@/view/goods/good'); // 轮播图
const goodsManage2 = () => import('@/view/goods/goods-manage2'); // 轮播图
const good2 = () => import('@/view/goods/good2'); // 轮播图
const goodCategory = () => import('@/view/goods/goods-category'); // 轮播图
// const showSetting = () => import('@/view/goods/show-setting'); // 轮播图
const priceSetting = () => import('@/view/goods/price-setting'); // 轮播图
const freight = () => import('@/view/goods/freight'); // 轮播图
const business = () => import('@/view/goods/business'); // 轮播图
const salesVolume = () => import('@/view/goods/sales-volume'); // 轮播图
const activity = () => import('@/view/goods/activity'); // 轮播图
const addActivityGoods = () => import('@/view/goods/add-activity-goods'); // 轮播图
const brandManage = () => import('@/view/goods/brand-manage'); // 轮播图
const batchBrand = () => import('@/view/goods/batch-brand'); // 轮播图

export default [{
        path: '/good',
        name: 'good',
        component: good
    },
    {
        path: '/goods-manage',
        name: 'goodsManage',
        component: goodsManage
    },{
        path: '/good2',
        name: 'good2',
        component: good2
    },
    {
        path: '/goods-manage2',
        name: 'goodsManage2',
        component: goodsManage2
    }, {
        path: '/goods-category',
        name: 'goodsCategory',
        component: goodCategory
    },
    // {
    //     path: '/show-setting',
    //     name: 'showSetting',
    //     component: showSetting
    // }, 
    {
        path: '/price-setting',
        name: 'priceSetting',
        component: priceSetting
    },
    {
        path: '/freight',
        name: 'freight',
        component: freight
    }, {
        path: '/business',
        name: 'business',
        component: business
    }, {
        path: '/sales-volume',
        name: 'salesVolume',
        component: salesVolume
    }, {
        path: '/activity',
        name: 'activity',
        component: activity
    }, {
        path: '/add-activity-goods',
        name: 'addActivityGoods',
        component: addActivityGoods
    }, {
        path: '/brand-manage',
        name: 'brandManage',
        component: brandManage
    }, {
        path: '/brand-brand',
        name: 'batchBrand',
        component: batchBrand
    }
];
